<template>
  <div>
    <history />
  </div>
</template>

<script>
import History from '@/components/history/history.vue'

export default {
  components: {
    History,
  },
  setup() {
    return {}
  },

  mounted() {
    //
  },
}
</script>
